<template>
  <li>
    <div class="flex items-center">
      <button
        type="button"
        class="-ml-6 text-white"
        :class="{'w-4': parent.link}"
        @click="active = !active"
      >
        <i
          class="w-4 fas"
          :class="active ? 'fa-caret-down' : 'fa-caret-right'"
        />
        <span
          v-if="!parent.link"
          class="ml-1 footer-link"
        >{{ parent.text }}</span>
      </button>

      <a
        v-if="parent.link"
        :href="parent.link"
        class="ml-2 footer-link"
        :target="parent.target && parent.target"
      >
        {{ parent.text }}
      </a>
    </div>

    <ul
      class="flex flex-col overflow-hidden"
      :class="{ 'h-0': !active }"
    >
      <li
        v-for="(child,index) in children"
        :key="index"
      >
        <a
          :href="child.link"
          class="text-xs sub-link"
          :target="child.target && child.target"
        >
          {{ child.text }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    parent: {
      required: true,
      type: Object,
    },

    children: {
      required: true,
      type: Array,
    },
  },

  data() {
    return {
      active: false,
    };
  },
};
</script>

<style scoped>
.sub-link {
  @apply text-white text-opacity-75;
}

.sub-link:hover {
  @apply text-white;
}
</style>
